import { H4 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { css, keyframes } from 'styled-components';

const loadIndicator = keyframes`
  0% {
    transform: scaleX(0);
  }
  99% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
`;

const animationRule = css`
  ${loadIndicator};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;

  ${QUERIES.largeTabletAndUp} {
    flex-direction: row;
  }
`;

export const MediaContainer = styled.div`
  display: block;
  width: 100%;
  overflow: hidden;

  ${QUERIES.tabletAndUp} {
    flex: 1;
    height: auto;
  }

  video {
    border-radius: 5px;
    display: block;
    width: 100%;
    height: 100%;
    aspect-ratio: 4/3;
  }
`;

export const Image = styled.div`
  display: block;
  width: 100%;
  background-image: ${({ bg }) => `url(${bg})`};
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  aspect-ratio: 4/3;
`;

export const LoadingIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  transform: scaleX(0);
  background-color: ${themeStyle.varBrandMain};
  transform-origin: left;
`;

export const TextBoxList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

export const TextBox = styled(H4)`
  position: relative;
  padding: 16px;
  background-color: ${({ isCurrent }) =>
    isCurrent ? themeStyle.varBlueLight : themeStyle.varBackgroundAlt};

  font-weight: ${({ isCurrent }) =>
    isCurrent ? themeStyle.fontBold : themeStyle.fontRegular};

  ${LoadingIndicator} {
    animation: ${animationRule};
    animation-duration: ${({ duration }) => duration}ms;
    animation-timing-function: linear;
    animation-play-state: ${({ isCurrent }) =>
      isCurrent ? 'running' : 'stopped'};
    animation-iteration-count: ${({ isCurrent }) =>
      isCurrent ? 'infinite' : 0};
  }

  p {
    margin: 0px;
  }
`;
